import { faBan, faCalendarDay, faClock, faPlayCircle, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SpaceBooking } from 'components/SpaceBooking/types';
import { timeDivisions } from 'components/TrainingPlan/TrainingPlanHelpers';
import moment from 'moment';

interface Props {
    booking: SpaceBooking;
}

export const SpaceBookingDatesComponent = ({ booking }: Props) => {
    return (
        <div className="tw-grid tw-grid-cols-[auto_1fr] tw-items-center tw-gap-x-5 tw-gap-y-1">
            <span className="tw-leading-4 tw-text-accents-8">
                <FontAwesomeIcon size="xs" icon={faPlayCircle} />
            </span>
            <p className="tw-font-size-[0.875em] tw-m-0 tw-text-accents-8">
                {moment(booking.start).format('dd, l') +
                    (booking.repeat_until ? ' bis ' + moment(booking.repeat_until).format('l') : '')}
            </p>
            {booking.repeat_period && (
                <>
                    <span className="tw-leading-4 tw-text-accents-8">
                        <FontAwesomeIcon size="xs" icon={faCalendarDay} />
                    </span>
                    <p className="tw-font-size-[0.875em] tw-m-0 tw-text-accents-8">{booking.repeat_period}</p>
                </>
            )}
            <span className="tw-leading-4 tw-text-accents-8">
                <FontAwesomeIcon size="xs" icon={faClock} />
            </span>
            <p className="tw-font-size-[0.875em] tw-m-0 tw-text-accents-8">{`${timeDivisions.times[booking.start_time]} bis ${
                timeDivisions.times[booking.end_time]
            }`}</p>
            <span className={`tw-leading-4 tw-text-accents-8 ${booking.cancelled_at ? 'tw-text-error' : ''}`}>
                <FontAwesomeIcon size="xs" icon={faBan} />
            </span>
            <p
                className={`tw-font-size-[0.875em] tw-m-0 tw-leading-4 tw-text-accents-8 ${booking.cancelled_at ? 'tw-text-error' : ''}`}
            >
                {moment(booking.cancelled_at || booking.cancelable_until).format('l')}
            </p>
            {booking.cancellation_reason && (
                <>
                    <span className={`tw-leading-4 tw-text-error`}>
                        <FontAwesomeIcon size="xs" icon={faStickyNote} />
                    </span>
                    <p className="tw-font-size-[0.875em] tw-m-0 tw-text-error">{booking.cancellation_reason}</p>
                </>
            )}
        </div>
    );
};
